import { useI18n } from 'vue-i18n'

import useBlProviders from '../providers/useBlProvider'
import StaffGroupsDt from '@/services/dataTransferModules/staffGroupsDt'

export default function useStaffGroups(params = {}) {
	const staffGroupsDt = new StaffGroupsDt()

	const { t: $t } = useI18n()

	const defaults = {
		creatingStaffGroup: {
			name: '',
		},
		fieldsToPatch: ['name'],
	}

	const {
		loadEntityFlags: flags,

		entities: fullStaffGroups,
		getEntities: getStaffGroups,

		createEntity: createStaffGroup,

		entity: staffGroup,
		getEntity: getStaffGroup,

		entityPopup: staffGroupsPopup,
		getEntityPopup: getStaffGroupsPopup,

		entityPreview: previewStaffGroups,
		getEntityPreview: getStaffGroupsPreview,

		patchEntity: patchStaffGroup,
		updateEntity: putStaffGroup,

		deleteEntity: deleteStaffGroup,
	} = useBlProviders(
		staffGroupsDt,
		Object.assign(
			{
				showErrorNotificationForLoadingAllEntities: true,
				errorNotificationTextForLoadingAllEntities: $t('Employees groups loaded with an error!'),

				showErrorNotificationForCreatingEntity: true,

				showErrorNotificationForLoadingOneEntity: true,

				showErrorNotificationForUpdatingEntity: true,

				showErrorNotificationForDeletingEntity: true,
			},
			params,
		),
	)

	return {
		flags,
		fullStaffGroups,
		previewStaffGroups,
		staffGroup,
		staffGroupsPopup,
		defaults,

		getStaffGroups,
		getStaffGroupsPreview,
		getStaffGroupsPopup,
		getStaffGroup,
		createStaffGroup,
		patchStaffGroup,
		putStaffGroup,
		deleteStaffGroup,
	}
}
